import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import type { UserRow, UserPermissions } from "@/types";

export function useUsers() {
  return useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const { data } = await apiClient.get<UserRow[]>("/users");
      return data;
    },
  });
}

export function useSetUserApproval() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, approved }: { id: string; approved: boolean }) => {
      await apiClient.patch(`/users/${id}/approval`, { approved });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["users"] }),
  });
}

export function useSetUserAdmin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, is_admin }: { id: string; is_admin: boolean }) => {
      await apiClient.patch(`/users/${id}/admin`, { is_admin });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["users"] }),
  });
}

export function useSetUserPermissions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...perms }: { id: string } & Partial<UserPermissions>) => {
      await apiClient.put(`/users/${id}/permissions`, perms);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["users"] }),
  });
}
